export default {
  label: 'Sentimiento',
  placeholder: 'Todos',
  notClassified: 'No Clasificados',
};
